import { Box, Flex } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
export const StatusDetailsRowZone = styled(Flex) `
  & {
    width: 100%;
    flex-wrap: wrap;
  }

  @media screen and (min-width: ${themeGet("breakpoints.xl")}) {
    & {
      width: 80%;
    }
  }
`;
export const StatusDetailsColumnZone = styled(Box) `
  & {
    width: 100%;
  }

  &:not(:first-of-type) {
    margin-top: ${themeGet("space.4")};
  }

  @media screen and (min-width: ${themeGet("breakpoints.md")}) {
    & {
      width: 70%;
    }
  }

  @media screen and (min-width: ${themeGet("breakpoints.lg")}) {
    & {
      width: 50%;
    }

    &:nth-of-type(odd) {
      padding-right: ${themeGet("space.6")};
    }

    &:nth-of-type(even) {
      padding-left: ${themeGet("space.6")};
    }

    &:not(:first-of-type) {
      margin-top: 0;
    }
  }

  @media screen and (min-width: ${themeGet("breakpoints.xl")}) {
    &:nth-of-type(odd) {
      padding-right: ${themeGet("space.10")};
    }

    &:nth-of-type(even) {
      padding-left: ${themeGet("space.10")};
    }
  }
`;
